import React, { Component } from 'react'
import Create from '../../../crud/create'
import fields from './reservation-fields'

class CreateSessionReservation extends Component<any, any> {
  render () {
    const { order } = this.props
    const orderPath = `/ecommerce/orders/${order.id}/manage`

    return (
      <Create
// @ts-ignore
        title='Create Session Reservation'
        fields={fields}
        apiPath='admin/session_reservations/multiply'
        successRedirectPath={orderPath}
        cancelRedirectPath={orderPath}
        onResourceCreated={this.props.onSessionReservationCreated}
        onCancel={this.props.onSessionReservationCanceled}
        resource={{
          order_id: order.id,
          multiplier: 1
        }}
      />
    )
  }
}

export default CreateSessionReservation
